import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { BankAccountDetails, BankAccountDetailsSchema } from './bank-account-details.entity';
import { BankAccountOwnership } from './bank-account-ownership.enum';

export const BankAccountSchema = WithBaseEntitySchema(
    z.object({
        bankAccountDetails: BankAccountDetailsSchema,
        ownership: EnumSchema(BankAccountOwnership),
    }),
).strict();

export class BankAccount extends FromSchema(BankAccountSchema) implements BaseEntity {
    id: string;
    bankAccountDetails: BankAccountDetails;
    ownership: BankAccountOwnership;
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    createdBy: Executor;
    seller: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
